import React, { useState, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const EMOJI_CATEGORIES = [
  {
    id: 'promo',
    name: 'Akasia POS & Ventas',
    icon: '🚀',
    emojis: [
      '🚀', '💻', '🖥️', '📱', '📲', '🛒', '🛍️', '💳', '💰', '💵', '🪙', '🏷️',
      '📦', '🚚', '🚛', '🏢', '🏪', '🧾', '📊', '📈', '📉', '💼', '📁', '📂',
      '📅', '📆', '☎️', '📞', '📠', '✉️', '📧', '📨', '📩', '💡', '🔑', '🔒',
      '🔓', '🔔', '🔕', '⚙️', '🔧', '🛠️', '🖨️', '🏧', '📝', '📋', '📌', '📍'
    ]
  },
  {
    id: 'faces',
    name: 'Caritas y Personas',
    icon: '😀',
    emojis: [
      '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃',
      '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜',
      '🤪', '🤨', '🧐', '🤓', '😎', '🥸', '🤩', '🥳', '😏', '😒', '😞', '😔',
      '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤',
      '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓',
      '🤗', '🤔', '🫣', '🤭', '🫢', '🫡', '🤫', '🫠', '🤐', '🥱', '😴', '🤤',
      '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🫰', '🤟',
      '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊',
      '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪'
    ]
  },
  {
    id: 'symbols',
    name: 'Símbolos y Estados',
    icon: '✅',
    emojis: [
      '✅', '✔️', '☑️', '❌', '❎', '✖️', '➕', '➖', '➗', '⚠️', '🚨', '⛔',
      '🚫', '❗', '❓', '❕', '❔', '💯', '💬', '🗨️', '🗯️', '💭', '💤', 'ℹ️',
      '🔴', '🟢', '🟡', '🔵', '🟣', '🟠', '⚫', '⚪', '🟩', '🟨', '🟥', '🟦',
      '⏳', '⌛', '⏰', '⏱️', '⏲️', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖',
      '🔄', '🔁', '🔂', '🔃', '▶️', '⏸️', '⏯️', '⏹️', '⏺️', '⏭️', '⏮️', '⏩',
      '⏪', '🔀', '🔊', '🔈', '🔉', '🔇', '©️', '®️', '™️', '🔝', '🆕', '🆓',
      '🆗', '🆘', '🆙', '🆒', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'
    ]
  },
  {
    id: 'celebration',
    name: 'Promociones y Festejo',
    icon: '🔥',
    emojis: [
      '🔥', '✨', '⭐', '🌟', '💫', '💥', '🎉', '🎊', '🎈', '🎁', '🏆', '🥇',
      '🥈', '🥉', '🏅', '🎖️', '👑', '💎', '🎯', '📢', '📣', '🎫', '🎟️', '🎪',
      '🎨', '🎬', '🎤', '🎧', '🎼', '🎵', '🎶', '🌈', '☀️', '🌤️', '⛅', '🌙'
    ]
  },
  {
    id: 'food',
    name: 'Alimentos y Lugares',
    icon: '☕',
    emojis: [
      '☕', '🍵', '🥤', '🧃', '🍺', '🍻', '🍷', '🍕', '🍔', '🍟', '🌭', '🍿',
      '🥪', '🌮', '🌯', '🥗', '🍝', '🍜', '🍣', '🍦', '🍨', '🍩', '🍪', '🎂',
      '🍰', '🍫', '🍬', '🍭', '🚗', '🚕', '🚙', '🚌', '🛵', '🏍️', '🚲', '🛴',
      '✈️', '🚁', '🛳️', '🚢', '🏠', '🏡', '🏢', '🏬', '🏭', '🗺️', '🧭', '🏖️'
    ]
  }
];

const EmojiPickerPopover = ({ onSelectEmoji, onClose, isDark = false }) => {
  const [activeTab, setActiveTab] = useState('promo');
  const [search, setSearch] = useState('');

  const currentCategory = useMemo(() => {
    return EMOJI_CATEGORIES.find(c => c.id === activeTab) || EMOJI_CATEGORIES[0];
  }, [activeTab]);

  const displayedEmojis = useMemo(() => {
    if (!search.trim()) {
      return currentCategory.emojis;
    }
    // Búsqueda en todas las categorías
    const all = EMOJI_CATEGORIES.flatMap(c => c.emojis);
    return Array.from(new Set(all));
  }, [search, currentCategory]);

  return (
    <div
      className="border rounded-3 shadow-lg p-2 d-flex flex-column"
      style={{
        width: '320px',
        height: '350px',
        maxHeight: '350px',
        backgroundColor: isDark ? '#182635' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0',
        zIndex: 1060,
        overflow: 'hidden',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.4)'
      }}
      onClick={e => e.stopPropagation()}
    >
      {/* Header con buscador y cerrar */}
      <div className="d-flex align-items-center gap-2 mb-2 pb-1 border-bottom flex-shrink-0" style={{ borderColor: isDark ? '#233142' : '#f1f5f9' }}>
        <div className="position-relative flex-grow-1">
          <input
            type="text"
            className="form-control form-control-sm px-2 py-1 shadow-none"
            placeholder="Buscar emoji..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{
              fontSize: '0.78rem',
              backgroundColor: isDark ? '#121e2d' : '#f8fafc',
              borderColor: isDark ? '#233142' : '#e2e8f0',
              color: isDark ? '#f9fafd' : '#0f172a'
            }}
            autoFocus
          />
        </div>
        {onClose && (
          <button
            type="button"
            className="btn btn-sm p-0 border-0 text-muted"
            onClick={onClose}
            title="Cerrar selector"
          >
            <FontAwesomeIcon icon={faTimes} style={{ fontSize: '0.8rem' }} />
          </button>
        )}
      </div>

      {/* Pestañas de categorías */}
      {!search.trim() && (
        <div className="d-flex align-items-center justify-content-between mb-2 px-1 border-bottom pb-1 flex-shrink-0" style={{ borderColor: isDark ? '#233142' : '#f1f5f9' }}>
          {EMOJI_CATEGORIES.map(cat => {
            const isActive = cat.id === activeTab;
            return (
              <button
                key={cat.id}
                type="button"
                className={`btn btn-sm p-1 rounded-2 border-0 ${isActive ? 'bg-success bg-opacity-25' : ''}`}
                style={{
                  fontSize: '1rem',
                  lineHeight: 1,
                  filter: isActive ? 'none' : 'grayscale(0.5)'
                }}
                onClick={() => setActiveTab(cat.id)}
                title={cat.name}
              >
                {cat.icon}
              </button>
            );
          })}
        </div>
      )}

      {/* Título de categoría actual */}
      <div className="px-1 mb-1 d-flex align-items-center justify-content-between flex-shrink-0">
        <span className="small text-muted fw-semibold" style={{ fontSize: '0.72rem' }}>
          {search.trim() ? 'Todos los emojis' : currentCategory.name}
        </span>
        <span className="text-muted" style={{ fontSize: '0.65rem' }}>
          {displayedEmojis.length} disponibles
        </span>
      </div>

      {/* Rejilla de emojis con scroll interno controlado */}
      <div
        className="p-1 flex-grow-1"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(8, 1fr)',
          gap: '2px',
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,
          scrollbarWidth: 'thin'
        }}
      >
        {displayedEmojis.map((emoji, idx) => (
          <button
            key={idx}
            type="button"
            className="btn btn-sm p-0 border-0 rounded d-flex align-items-center justify-content-center"
            style={{
              width: '34px',
              height: '34px',
              fontSize: '1.2rem',
              lineHeight: 1,
              backgroundColor: 'transparent'
            }}
            onClick={() => onSelectEmoji(emoji)}
            title={`Insertar ${emoji}`}
          >
            {emoji}
          </button>
        ))}
      </div>

      {/* Footer informativo */}
      <div className="pt-1 mt-1 border-top text-center flex-shrink-0" style={{ borderColor: isDark ? '#233142' : '#f1f5f9' }}>
        <span className="text-muted" style={{ fontSize: '0.68rem' }}>
          💡 Usa <kbd style={{ fontSize: '0.62rem' }}>Win + .</kbd> para abrir todo el catálogo de Windows
        </span>
      </div>
    </div>
  );
};

export default EmojiPickerPopover;
